import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=55e58830&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=js&"
export * from "./InvitationItem.vue?vue&type=script&lang=js&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvitationItem.vue?vue&type=style&index=1&id=55e58830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e58830",
  null
  
)

export default component.exports